
import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, Calendar, Users, Calendar as CalendarIcon } from 'lucide-react';

const TourUpdates = () => {
  return (
    <section className="py-16 bg-[#F7F0DE]" aria-labelledby="tour-updates-heading">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <h2 
            className="text-3xl md:text-4xl font-montserrat font-bold mb-8 text-center text-[#3E2723]" 
            id="tour-updates-heading"
          >
            Tour Availability
          </h2>
          
          {/* Static Tour Availability Section */}
          <section className="bg-[#F5EDE0] p-6 rounded-lg shadow-sm" aria-labelledby="availability-heading">
            <h3 id="availability-heading" className="text-2xl font-montserrat font-semibold mb-4 text-[#3E2723]">Our Tours</h3>
            
            <div className="grid grid-cols-1 gap-3 mb-6">
              <div className="bg-white p-4 rounded-md shadow-sm flex flex-col sm:flex-row justify-between border border-[#3E2723]/10">
                <div className="flex items-start mb-3 sm:mb-0">
                  <Calendar size={20} className="text-[#F97316] mr-3 mt-1 flex-shrink-0" />
                  <div>
                    <p className="font-semibold text-[#3E2723]">Brooklyn Heights Tour</p>
                    <p className="text-sm text-[#3E2723]/70">Weekends at 10:00 AM</p>
                  </div>
                </div>
                <div className="flex items-center">
                  <Link 
                    to="/tours/brooklyn-heights" 
                    className="text-[#F97316] font-medium text-sm hover:text-[#EA580C] flex items-center transition-colors"
                  >
                    View Details
                  </Link>
                </div>
              </div>
              
              <div className="bg-white p-4 rounded-md shadow-sm flex flex-col sm:flex-row justify-between border border-[#3E2723]/10">
                <div className="flex items-start mb-3 sm:mb-0">
                  <Calendar size={20} className="text-[#F97316] mr-3 mt-1 flex-shrink-0" />
                  <div>
                    <p className="font-semibold text-[#3E2723]">Financial District Tour</p>
                    <p className="text-sm text-[#3E2723]/70">Saturdays at 2:00 PM</p>
                  </div>
                </div>
                <div className="flex items-center">
                  <Link 
                    to="/tours/financial-district" 
                    className="text-[#F97316] font-medium text-sm hover:text-[#EA580C] flex items-center transition-colors"
                  >
                    View Details
                  </Link>
                </div>
              </div>
              
              <div className="bg-white p-4 rounded-md shadow-sm flex flex-col sm:flex-row justify-between border border-[#3E2723]/10">
                <div className="flex items-start mb-3 sm:mb-0">
                  <Calendar size={20} className="text-[#F97316] mr-3 mt-1 flex-shrink-0" />
                  <div>
                    <p className="font-semibold text-[#3E2723]">Lower East Side Tour</p>
                    <p className="text-sm text-[#3E2723]/70">Sundays at 2:00 PM</p>
                  </div>
                </div>
                <div className="flex items-center">
                  <Link 
                    to="/tours/lower-east-side" 
                    className="text-[#F97316] font-medium text-sm hover:text-[#EA580C] flex items-center transition-colors"
                  >
                    View Details
                  </Link>
                </div>
              </div>
            </div>
            
            <div className="flex justify-center">
              <Link 
                to="/booking" 
                className="inline-flex items-center justify-center bg-[#F97316] hover:bg-[#EA580C] hover:text-white text-white px-8 py-4 rounded-lg font-montserrat font-semibold transition-all duration-300 hover:-translate-y-1 hover:shadow-lg gap-2 min-w-[240px]"
              >
                <CalendarIcon size={22} />
                <span>Check Available Dates</span>
              </Link>
            </div>
          </section>
          
          <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-sm border border-[#C58B65]/10">
              <div className="flex items-center mb-4 text-[#F97316]">
                <Calendar className="mr-2" size={24} />
                <h3 className="text-xl font-bold font-montserrat">Flexible Scheduling</h3>
              </div>
              <p className="text-[#3E2723]/80">
                Can't make these dates? We frequently add new tours to our schedule. Check back or join our waitlist to be notified when new dates become available.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm border border-[#C58B65]/10">
              <div className="flex items-center mb-4 text-[#F97316]">
                <Clock className="mr-2" size={24} />
                <h3 className="text-xl font-bold font-montserrat">Tour Duration</h3>
              </div>
              <p className="text-[#3E2723]/80">
                All tours last approximately 2 hours and cover about 1-1.5 miles at a leisurely pace with frequent stops. Comfortable walking shoes are recommended.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm border border-[#C58B65]/10">
              <div className="flex items-center mb-4 text-[#F97316]">
                <Users className="mr-2" size={24} />
                <h3 className="text-xl font-bold font-montserrat">Group Size</h3>
              </div>
              <p className="text-[#3E2723]/80">
                We keep our tour groups intimate with a maximum of 15 participants to ensure everyone can hear our guides and enjoy a personalized experience.
              </p>
            </div>
          </div>
          
          <div className="mt-10 text-center">
            <Link 
              to="/booking" 
              className="inline-flex items-center justify-center bg-[#F97316] hover:bg-[#EA580C] hover:text-white text-white px-8 py-4 rounded-lg font-montserrat font-semibold transition-all duration-300 hover:-translate-y-1 hover:shadow-lg gap-2 min-w-[240px]"
            >
              <CalendarIcon size={22} />
              <span>See All Available Dates</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TourUpdates;
